module.exports = __webpack_public_path__ + "static/media/Aqi-Moderate.d2f53871.png";